export const findInCircularList = <T,>(
  list: T[],
  from: number,
  criteria: (item: T) => boolean = () => true,
  step = 1,
  // eslint-disable-next-line max-params
): number => {
  for (
    let i = (from + step + list.length) % list.length;
    i !== from && from > -1;
    i = (i + step + list.length) % list.length
  ) {
    if (criteria(list[i])) return i;
  }

  return from; // return same item
};
